import styled from 'styled-components';
import KitCard from '@avtkit/controls/Card';
import { MOBILE_BP } from '../constants';

export const Card = styled(KitCard)`
   @media screen and (max-width: ${MOBILE_BP}) {
      padding: 25px 25px;
   }
`;
